import Service from "../../Services/index";

const Auth = {
    namespaced: true,
    state: {
        user: null,
        accessToken: null,
        registerToken : null,
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.accessToken = token;
        },

        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_TOKEN_REGISTER : (state, token) => {
            state.registerToken = token;
        },
    },
    actions: {
        login({ commit }, data) {
            return Service.auth.login(data).then(data => {
                commit("SET_TOKEN", data.success.token);
                return data;
            });
        },
        register({ commit }, data) {
            return Service.auth.register(data).then(data => {
                commit("SET_TOKEN_REGISTER", data.success.token);
                return data;
            });
        },
        setUser({ commit, state }) {
            return Service.auth
                .getUser()
                .then(data => commit("SET_USER", data))
                .catch(err => Promise.reject(err));
        },
        getToken({ commit }, data) {
            return Service.auth.getToken(data).then(data => {
                commit("SET_TOKEN", data.success.token);
            }).catch(err => Promise.reject(err));

            // return Service.auth.getToken(data);
        },

        createFingerPrint({ commit },data) {
            return Service.auth.createFingerPrint(data);
        },
        logout({ commit }) {
            return Service.auth.logout().then(()=>{
                commit("SET_USER", null);
                commit("SET_TOKEN", null);
                // localStorage.removeItem('vuex');
            })
        }
    }
};

export default Auth;
